// import styles
import '@scss/main.scss';
import '@lib/scss/base.lib.scss';
// require main js file
require('@js/index');
require('@js/header');
require('@js/scroll-down');
require('@js/video');
require('@js/sliders');
require('@js/ajax');
require('@js/cursor');
require('@js/animations');
